module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__vergleich-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": 3,
      "sidebar_left_collapse": _vm.sidebar_left_collapse,
      "sidebar_right_collapse": _vm.sidebar_right_collapse
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-1"
    },
    slot: "sidebar-1"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "sidebarPageStyle": 'margin: 10px 20px 10px 15px',
      "seiteIdx": _vm.seiteIdx
    },
    on: {
      "changeSeite": _vm.changeSeite
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__vergleich-main"
  }, [_c('div', {
    staticClass: "ksm-vergleich-content"
  }, [_c('deepzoom-view', {
    key: "deep_vergleich_1",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-xy-center",
    staticStyle: {
      "width": "36px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1px",
      "height": "100%",
      "background-color": "grey"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-vergleich-content"
  }, [_c('deepzoom-view', {
    key: "deep_vergleich_2",
    attrs: {
      "modusOption": _vm.b_modusOption,
      "seiteIdx": _vm.b_seiteIdx,
      "seiten": _vm.b_seiten
    },
    on: {
      "changePage": _vm.b_changeSeite
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.b_merz,
      "modusOption": _vm.b_modusOption,
      "seiteIdx": _vm.b_seiteIdx
    },
    on: {
      "changeSeite": _vm.b_changeSeite
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96461186","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modus/Vergleich.vue
// module id = 1987
// module chunks = 1